import {observable} from 'mobx';
import {createInstance, ModelProperties} from 'utils';

import {SeoApp} from './seo-app';
import {Language} from './language';
import {SeoLocaleCategory} from './seo-locale-category';

export class SeoAppSync {
    @observable id!: number;

    @observable synced!: boolean;

    @observable appId!: number;

    @observable categoryId!: number;

    @observable languageId!: number;

    @observable app?: SeoApp;

    @observable category?: SeoLocaleCategory;

    @observable language?: Language;

    constructor(status?: ModelProperties<SeoAppSync>) {
        if (status) {
            Object.assign(this, status);
            this.app = createInstance(SeoApp, status.app);
            this.language = createInstance(Language, status.language);
            this.category = createInstance(SeoLocaleCategory, status.category);
        }
    }
}